/**
 * @name vector-square
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuMDU1IDQuNTMzYTI0IDI0IDAgMDAtMTAuMTEgMCIgLz4KICA8cGF0aCBkPSJNMTkuNDY3IDE3LjA1NWEyNCAyNCAwIDAwMC0xMC4xMSIgLz4KICA8cGF0aCBkPSJNNC41MzMgNi45NDVhMjQgMjQgMCAwMDAgMTAuMTEiIC8+CiAgPHBhdGggZD0iTTYuOTQ1IDE5LjQ2N2EyNCAyNCAwIDAwMTAuMTEgMCIgLz4KICA8Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjE5IiBjeT0iNSIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSI1IiBjeT0iMTkiIHI9IjIiIC8+CiAgPGNpcmNsZSBjeD0iNSIgY3k9IjUiIHI9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/vector-square
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const VectorSquare: string = `
<svg
  class="lucide lucide-vector-square"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M17.055 4.533a24 24 0 00-10.11 0" />
  <path d="M19.467 17.055a24 24 0 000-10.11" />
  <path d="M4.533 6.945a24 24 0 000 10.11" />
  <path d="M6.945 19.467a24 24 0 0010.11 0" />
  <circle cx="19" cy="19" r="2" />
  <circle cx="19" cy="5" r="2" />
  <circle cx="5" cy="19" r="2" />
  <circle cx="5" cy="5" r="2" />
</svg>
`;

export default VectorSquare;
